import { render, staticRenderFns } from "./RulesEdit.vue?vue&type=template&id=e23b70ec&scoped=true"
import script from "./RulesEdit.vue?vue&type=script&lang=js"
export * from "./RulesEdit.vue?vue&type=script&lang=js"
import style0 from "./RulesEdit.vue?vue&type=style&index=0&id=e23b70ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23b70ec",
  null
  
)

export default component.exports